/* jshint esversion:6 */
import React from 'react';
import PropTypes from 'prop-types';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import RepeatPostControl from 'app/components/PostModal/RepeatPostControl.jsx';
import EverqueuePanel from 'app/components/PostModal/EverqueuePanel.jsx';
import SchedulePanel from 'app/components/PostModal/SchedulePanel.jsx';
import CategoryPanel from 'app/components/PostModal/CategoryPanel.jsx';
import GMBPanel from 'app/components/PostModal/GMBPanel.jsx';
import ModalUpgradePanel from 'app/components/Subscription/ModalUpgradePanel.jsx';

class PostConfigPanels extends React.Component {
    constructor(props) {
        super(props);

        this.upgradeAction = this.upgradeAction.bind(this);

    }

    upgradeAction(e) {

        let constants = this.props.app.config.constants;

        if (e) {
            e.preventDefault();
        }

        if (!this.props.isFreeUser()) {
            window.location = '/account/subscription/plus';
        } else {
            window.location = '/account/subscription/new?plan=9';
        }

    }

    render () {
        let panel = null,
            panelName = '',
            content = null,
            subhead = null,
            constants = this.props.app.config.constants,
            upgradeLabel = 'Try it Free';

        if (this.props.panels.repeat) {
            panelName = 'repeat';
            content = (
                <RepeatPostControl {...this.props}/>
            );
        } else if (this.props.panels.everqueue) {
            panelName = 'everqueue';
            if (this.props.user.perms.resources && !this.props.user.perms.resources.everQ) {
                if (this.props.user.detail.trialEligible) {
                    subhead = (
                        <span>
                            <p>{"Upgrade to Plus today to unlock EverQueue and more."}</p>
                            <p>Take it for a test spin, {"it's"} <span className="power-up">FREE</span> for 7 days.</p>
                        </span>
                    );
                } else if (!this.props.isFreeUser() && this.props.user.perms.resources.plusTrialAvailable) {
                    subhead = (
                        <span>
                            <p>{"Upgrade to Plus today to unlock EverQueue and more."}</p>
                            <p>Take it for a test spin with a FREE 30 day trial.</p>
                        </span>
                    );
                    upgradeLabel = "START YOUR TRIAL NOW";
                } else {
                    subhead = (
                        <span>
                            <p>{"Upgrade to Plus today to unlock EverQueue and more."}</p>
                            <p>Take it for a spin and supercharge your social media.</p>
                        </span>
                    );
                    upgradeLabel = "Get Plus with Everqueue";
                }
                return (
                    <ModalUpgradePanel
                        {...this.props}
                        headline={"Recycle Your Best Social Media Posts. Endlessly."}
                        subhead={subhead}
                        actionLabel={upgradeLabel}
                        onClick={this.upgradeAction}
                        panelName={panelName} />
                )
            } else {
                content = (
                    <EverqueuePanel {...this.props}/>
                );
            }

        } else if (this.props.panels.category) {
            panelName = 'category';
            if (this.props.user.perms.resources && !this.props.user.perms.resources.categories) {
                if (this.props.user.detail.trialEligible) {
                    subhead = (
                        <span>
                            <p>{"Upgrade to Plus today to unlock Content Categories and more."}</p>
                            <p>Take it for a test spin, {"it's"} <span className="power-up">FREE</span> for 7 days.</p>
                        </span>
                    );
                } else if (!this.props.isFreeUser() && this.props.user.perms.resources.plusTrialAvailable) {
                    subhead = (
                        <span>
                            <p>{"Upgrade to Plus today to unlock Content Categories and more."}</p>
                            <p>Take it for a test spin with a FREE 30 day trial.</p>
                        </span>
                    );
                    upgradeLabel = "START YOUR TRIAL NOW";
                } else {
                    subhead = (
                        <span>
                            <p>{"Upgrade to Plus today to unlock Content Categories and more."}</p>
                            <p>Take it for a spin and supercharge your social media.</p>
                        </span>
                    );
                    upgradeLabel = "Get Plus";
                }
                return (
                    <ModalUpgradePanel
                        {...this.props}
                        headline={"Share the perfect content. Every time."}
                        subhead={subhead}
                        actionLabel={upgradeLabel}
                        onClick={this.upgradeAction}
                        panelName={panelName} />
                )
            } else {
                content = (
                    <CategoryPanel {...this.props}/>
                );
            }

        } else if (this.props.panels.scheduler) {
            panelName = 'scheduler';
            content = (
                <SchedulePanel {...this.props}/>
            );
        } else if (this.props.panels.gmb) {
            panelName = "gmb";
            content = (
                <GMBPanel {...this.props}/>
            );
        }

        if (content !== null) {
            panel = (
                <div className="post-modal-config panel">
                    <div className="dismiss-panel" onClick={this.props.activateAccessory} data-accessory={panelName} role="button" aria-label="close option">
                        <i className="ion-arrow-down-a"></i>
                    </div>
                    {content}
                </div>
            )
        }

        return panel;
    }
}

PostConfigPanels.displayName = "PostConfigPanels";

PostConfigPanels.propTypes = {
    panels: PropTypes.object,
    post: PropTypes.object,
    requestChange: PropTypes.func,
    activateAccessory: PropTypes.func,
    setPostAttribute: PropTypes.func
};

PostConfigPanels.defaultProps = {
    panels: {},
    post: {},
    requestChange: null,
    activateAccessory: null,
    setPostAttribute: null
};

export default PostConfigPanels;
